import { z } from 'zod';

const paymentObjectSchema = z.object({
  workerName: z.string(),
  paymentId: z.string(),
  creationDate: z.string(),
  invoiceNumber: z.string(),
  status: z.string(),
  dueDate: z.string(),
  invoiceUrl: z.string().nullish(),
});

export const paymentInfiniteResponseSchema = z.object({
  totalRows: z.number(),
  nextPage: z.number().optional(),
  items: z.array(paymentObjectSchema),
});

export type PaymentInfiniteResponse = z.infer<typeof paymentInfiniteResponseSchema>;
